import { PageAPI } from 'lib/api/';

export const SCORING_DATA_LOADED = 'SCORING_DATA_LOADED';

export function scoringDataLoaded(influencers) {
    return {
        type: SCORING_DATA_LOADED,
        influencers
    };
}

export function loadScoringData() {
    return (dispatch, getState) => {
        const { app: { query = {} } } = getState();
        return PageAPI.getScoringInfluencers(query)
        .then((influencers) => dispatch(scoringDataLoaded(influencers)));
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/scoringActions.js